<div class="main-wrapper-section">
    <div class="common-header">
        <h3>Employee Manager</h3>
    </div>
    <div class="card-section">
        <div class="card-panel">
            <div class="field-form-panel">
                <div class="flex-form">
                    <div class="form-group">
                        <label>Manager</label>
                        <kendo-combobox [data]="clpUsersDD"
                                        class="form-control"
                                        [valuePrimitive]="true"
                                        [kendoDropDownFilter]="filterSettings"
                                        [filterable]="true"
                                        textField="text"
                                        [(ngModel)]="selectedUserID"
                                        (valueChange)="getSearchFilter()"
                                        valueField="value">
                        </kendo-combobox>
                    </div>
                    <div class="form-group">
                        <label>Roles</label>
                        <kendo-combobox [data]="allRolesList"
                                        class="form-control"
                                        [valuePrimitive]="true"
                                        [kendoDropDownFilter]="filterSettings"
                                        [filterable]="true"
                                        textField="roleName"
                                        [(ngModel)]="roleName"
                                        (valueChange)="getSearchFilter()"
                                        valueField="roleName">
                        </kendo-combobox>
                    </div>
                    <div class="form-group">
                        <label>Sites</label>
                        <kendo-combobox [data]="allSitesList"
                                        class="form-control"
                                        [valuePrimitive]="true"
                                        [kendoDropDownFilter]="filterSettings"
                                        [filterable]="true"
                                        textField="text"
                                        [(ngModel)]="selectedSiteID"
                                        (valueChange)="getSearchFilter()"
                                        valueField="value">
                        </kendo-combobox>
                    </div>
                </div>
            </div>
            <div class="button-group">
                <div class="form-group">
                    <div class="button-group">
                        <!--<button class="primary-btn" (click)="getSearchFilter()">Filter</button>-->
                        <!--<button class="primary-btn margin-left15">Download</button>-->
                        <button class="primary-btn margin-left15" (click)="openEmployee()">Add New Employee &nbsp;<i class="fa fa-plus"></i></button>
                    </div>
                </div>
            </div>
            <div class="table-panel">
                <div class="">
                    <div class="text-right">
                        <div class="button-group" style="border:none;">
                        </div>
                    </div>
                </div>
                <div class="table-body employees">
                    <table mat-table [dataSource]="dataSource" class="emp-table" matSort>
                        <ng-container matColumnDef="userName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Employee</th>
                            <td mat-cell *matCellDef="let element">{{element.userName}}</td>
                        </ng-container>
                        <ng-container matColumnDef="siteName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Site</th>
                            <td mat-cell *matCellDef="let element">{{element.siteName}}</td>
                        </ng-container>
                        <ng-container matColumnDef="phoneNumber">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone</th>
                            <td mat-cell *matCellDef="let element">{{element.phoneNumber | phoneFormat}}</td>
                        </ng-container>
                        <ng-container matColumnDef="email">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                            <td mat-cell *matCellDef="let element">{{element.email}}</td>
                        </ng-container>
                        <ng-container matColumnDef="roleName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Role</th>
                            <td mat-cell *matCellDef="let element">{{element.roleName}}</td>
                        </ng-container>
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>Action</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="d-flex justify-content-center gap-4">
                                    <button class="btn mr-2 new-btn-edit" (click)="onEdit(element)"><span><i class="fa fa-pencil"></i> </span></button>
                                    <button class="btn new-btn-delete " data-toggle="modal" data-target="#deleteRoleModal" (click)="openDltConfirm(element)"><span> <i class="fa fa-trash"></i></span></button>
                                </div>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
                            [ngClass]="{'selected-row': selectedRowIndex == row.sn}">
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="employeeModal" class="modal fade" role="dialog" data-backdrop="static">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{isEditMem ? 'Edit Employee' : 'Add Employee'}} </h4>
                <button type="button" class="close" (click)="hideModalEmployee()">&times;</button>
            </div>
            <div class="modal-body">
                <div class="edit-panel" style="padding:20px;">
                    <div class="edit-colunm full-width">
                        <div [hidden]="!isEmployeeCreate">
                            <form [formGroup]="addEmployeeForm">
                                <div class="row row-extended">
                                    <div class="col-sm-4">
                                        <label class="fldtitle">Employee Name</label>
                                        <div *ngIf="!isEditMem">
                                            <kendo-combobox [data]="clpUsersDD"
                                                            class="form-control"
                                                            [valuePrimitive]="true"
                                                            [kendoDropDownFilter]="filterSettings"
                                                            [filterable]="true"
                                                            textField="text"
                                                            formControlName="employeeName"
                                                            valueField="value">
                                            </kendo-combobox>
                                            <div *ngIf="addEmployeeForm.controls.employeeName.errors && (addEmployeeForm.controls.employeeName.touched || addEmployeeForm.controls.employeeName.dirty)">
                                                <div class="login-error" *ngIf="addEmployeeForm.controls.employeeName.errors.required">Employee is required. </div>
                                            </div>
                                        </div>
                                        <div *ngIf="isEditMem">
                                            <span>{{selectedEmp?.userName}}</span>
                                        </div>
                                        
                                    </div>
                                    <div class="col-sm-4">
                                        <label class="fldtitle">Role</label>
                                        <kendo-dropdownlist [data]="allRolesList"
                                                            #dropdownlist
                                                            [filterable]="true"
                                                            formControlName="role"
                                                            (close)="onClose($event)"
                                                            (filterChange)="handleFilter($event)">
                                            <ng-template kendoDropDownListNoDataTemplate>
                                                <div>
                                                    No data found.
                                                    <button class="add-new" *ngIf="filter" kendoButton (click)="addNew()">
                                                        Add new
                                                    </button>
                                                </div>
                                            </ng-template>
                                        </kendo-dropdownlist>

                                        <div *ngIf="addEmployeeForm.controls.role.errors && (addEmployeeForm.controls.role.touched || addEmployeeForm.controls.role.dirty)">
                                            <div class="login-error" *ngIf="addEmployeeForm.controls.role.errors.required">Please Select a Role or Add a New Role. </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <label class="fldtitle">Site</label>
                                        <kendo-combobox [data]="sites"
                                                        class="form-control"
                                                        [valuePrimitive]="true"
                                                        [kendoDropDownFilter]="filterSettings"
                                                        [filterable]="true"
                                                        textField="siteName"
                                                        formControlName="site"
                                                        valueField="siteID">
                                        </kendo-combobox>
                                        <div *ngIf="addEmployeeForm.controls.site.errors && (addEmployeeForm.controls.site.touched || addEmployeeForm.controls.site.dirty)">
                                            <div class="login-error" *ngIf="addEmployeeForm.controls.site.errors.required">Please Select the Site. </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="form-group center">
                    <button class="btn primary-btn" type="submit" (click)="saveEmployee()">Save <i *ngIf="showSpinner" class="fa fa-spinner fa-spin"></i></button>
                    <button class="btn secondary-btn" type="button" (click)="hideModalEmployee()">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="deleteRoleModal" class="modal fade" role="dialog" data-backdrop="static">
    <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Confirmation</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body" style="padding:10px">
                <h6 class="modal-title">Are you sure you want to delete this employee</h6>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-success" (click)="onDeleteEmp()">Confirm</button>
                <button type="button" class="btn btn-cancel" data-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>
